import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"subway-line"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 6C21 7.10457 20.1046 8 19 8C17.8954 8 17 7.10457 17 6C17 4.89543 17.8954 4 19 4C20.1046 4 21 4.89543 21 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 6C21 7.10457 20.1046 8 19 8C17.8954 8 17 7.10457 17 6C17 4.89543 17.8954 4 19 4C20.1046 4 21 4.89543 21 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 18C8 19.1046 7.10457 20 6 20C4.89543 20 4 19.1046 4 18C4 16.8954 4.89543 16 6 16C7.10457 16 8 16.8954 8 18Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 6H17M17 6C17 7.10457 17.8954 8 19 8M17 6C17 4.89543 17.8954 4 19 4M19 3V4M19 4C20.1046 4 21 4.89543 21 6C21 7.10457 20.1046 8 19 8M8 18H19V8M8 18C8 19.1046 7.10457 20 6 20M8 18C8 16.8954 7.10457 16 6 16M6 20V21M6 20C4.89543 20 4 19.1046 4 18M3 18H4M4 18C4 16.8954 4.89543 16 6 16M6 3V16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SubwayLine = Vue.extend<IconProps>({
  name: 'SubwayLineIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'subway-line',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SubwayLine;
